import React from 'react';

const UnderDevelopment = () => {
    return (
        <div className="under-development">
            <div className="under-development__content">
                <h2 className="under-development__title">СТРАНИЦА НА СТАДИИ РАЗРАБОТКИ</h2>
            </div>
        </div>
    );
};

export default UnderDevelopment; 